export default __webpack_public_path__ + "1ef56b57c80d8c7a30819d9a4b787d2b.jpg";